module.exports = __webpack_public_path__ + "static/business-stripped-bare-165b207fbc72ee3c3db70bc063611a97.jpg";